import * as React from 'react';

import { IAdditionalService } from '../../types/promoInfo';
import { AdditionalServiceCardDefault, AdditionalServiceCardExtended } from './components';

interface IAdditionalServiceCardProps {
  data: IAdditionalService;
  isExtendedCard: boolean;
  onAboutClick: () => void;
  extraActions?: React.ReactNode;
}

/**
 * Карточка в секции "Способы взаиморасчётов".
 */
export const AdditionalServiceCard: React.FC<IAdditionalServiceCardProps> = ({
  data,
  isExtendedCard,
  onAboutClick,
  extraActions,
}) => {
  const { title, details, badge, icon, image, price, advertisingNotice } = data;

  return isExtendedCard ? (
    <AdditionalServiceCardExtended
      title={title}
      details={details}
      badge={badge}
      icon={icon}
      image={image}
      price={price}
      onAboutClick={onAboutClick}
      advertisingNotice={advertisingNotice}
      extraActions={extraActions}
    />
  ) : (
    <AdditionalServiceCardDefault
      title={title}
      icon={icon}
      details={details}
      price={price}
      onAboutClick={onAboutClick}
      advertisingNotice={advertisingNotice}
      extraActions={extraActions}
    />
  );
};
